import type { ReactNode } from "react"

interface SurfaceCardProps {
  children: ReactNode
  className?: string
}

export function SurfaceCard({ children, className = "" }: SurfaceCardProps) {
  return (
    <div
      className={`rounded-xl backdrop-blur-sm p-4 border transition-shadow duration-200 ease-out ${className}`}
      style={{
        backgroundColor: "var(--hexa-surface)",
        borderColor: "var(--hexa-border)",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.35)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = "0 12px 32px rgba(15, 23, 42, 0.45)"
        e.currentTarget.style.backgroundColor = "var(--hexa-surface-hover)"
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "0 8px 24px rgba(15, 23, 42, 0.35)"
        e.currentTarget.style.backgroundColor = "var(--hexa-surface)"
      }}
    >
      {children}
    </div>
  )
}
